/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Options/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import AvatarWrapper from 'DesignSystem/AvatarWrapper/index'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaIconExpandMore from 'DesignSystem/Svgs/TysiaIconExpandMore/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Options({
  children,
  viewPath = "/App/Account/Topbar/Options",
  buttonRef,
  onClick,
  onMouseEnter,
  onMouseLeave,
  hovered,
  selected,
  contentRef
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({onMouseEnter,onMouseLeave})
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let globalUserValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'user',
format: fromFormat.initials,
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<button
  data-testid="Options.Horizontal"
  data-view-path={viewPath}
 ref={buttonRef}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--ml-1-tY85I': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-2-tY85I': hovered ? dtColorsNeutral700 : selected ? dtColorsNeutral700 : dtColorsNeutral800}}
 className={`views-block ${styles.Horizontal}`}
>
<AvatarWrapper
  viewPath={`${viewPath}/AvatarWrapper`}
 width={30}
 height={30}
 data="global.user"
 format="/Data/format.js initials"
 initials={globalUserValueData}
 marginRight={dtSpaceXxxs}
/>
<div
  data-testid="Options.Horizontal:1"
  data-view-path={viewPath}
 style={{'--r-3-tY85I': selected ? "180deg" : "0deg"}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaIconExpandMore
  viewPath={`${viewPath}/TysiaIconExpandMore`}
 width={16}
 height={16}
 fill={dtColorsWhite}
/>
</div>
</button>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 innerRef={contentRef}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}